import script from "./SingleMineral.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleMineral.vue?vue&type=script&setup=true&lang=js"

import "./SingleMineral.vue?vue&type=style&index=0&id=28293701&lang=css"

const __exports__ = script;

export default __exports__